import { render } from "./EditType.vue?vue&type=template&id=230095d5"
import script from "./EditType.vue?vue&type=script&lang=js"
export * from "./EditType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__